"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavItemInner = exports.NavItemContent = exports.NavItemContainerWithChevron = exports.NavItemContainer = exports.IconAnimationContainer = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const {
  borderRadius,
  animation
} = _uiKit.theme;
const NavItemContainer = exports.NavItemContainer = _styledComponents.default.li.withConfig({
  displayName: "NavItemstyle__NavItemContainer",
  componentId: "sc-44278x-0"
})(["height:100%;display:flex;align-items:center;"]);
const NavItemInner = exports.NavItemInner = _styledComponents.default.span.withConfig({
  displayName: "NavItemstyle__NavItemInner",
  componentId: "sc-44278x-1"
})(["position:relative;padding:2px;display:block;line-height:1.5;transition:background-color ", ",transform ", ";", ";"], animation.DURATION, animation.DURATION, props => {
  if (props.showAsButton) {
    if (props.hovering) {
      return "\n          background-color: ".concat(_uiKit.theme.colours.WHITE, ";\n          border-radius: ").concat(borderRadius.default, ";\n          padding: 4px 15px 6px 15px;\n        ");
    }
    return "\n        border-radius: ".concat(borderRadius.default, ";\n        padding:  4px 15px 6px 15px;\n        transform: scale(1);\n        background-color: ").concat(_uiKit.theme.colours.WHITE, ";\n    ");
  }
  return null;
});
const NavItemContent = exports.NavItemContent = _styledComponents.default.span.withConfig({
  displayName: "NavItemstyle__NavItemContent",
  componentId: "sc-44278x-2"
})(["line-height:1.5;transition:transform ", ";display:block;"], animation.DURATION);
const NavItemContainerWithChevron = exports.NavItemContainerWithChevron = _styledComponents.default.div.withConfig({
  displayName: "NavItemstyle__NavItemContainerWithChevron",
  componentId: "sc-44278x-3"
})(["display:flex;align-items:center;gap:8px;svg{transform-origin:center;transition:transform 0.2s ease-in;", "}"], props => {
  if (props.selected) {
    return 'transform: rotate(-180deg);';
  }
  return '';
});
const IconAnimationContainer = exports.IconAnimationContainer = _styledComponents.default.div.withConfig({
  displayName: "NavItemstyle__IconAnimationContainer",
  componentId: "sc-44278x-4"
})(["", ""], _ref => {
  let {
    shouldAnimate
  } = _ref;
  return shouldAnimate && "\n    @keyframes lookAtMe {\n      0% {transform: scale(1) rotate(0deg);}\n      1.875% {transform: rotate(-22deg);}\n      3.75% {transform: scale(1.2) rotate(22deg);}\n      5.625% {transform: rotate(-22deg);}\n      7.5% {transform: scale(1) rotate(0deg);}\n      100% {transform: scale(1) rotate(0deg);}\n    }\n    animation: 10s ease-in-out 3s infinite lookAtMe;\n    ";
});